var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","padding-top":"70px"}},[_c('slide-navbar-component'),_c('navbar-component'),_c('carousel-layout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }